export class FilterBase {
    public search: string;   
    public orderBy: string;
    public isDesc: boolean;
    public skip: number;
    public take: number;
}
